import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { Seo } from "@/components/Seo";

const NotFoundPage = () => {
  const { lang, lp } = useLang();
  const de = lang === "de";
  return (
    <section data-testid="not-found-page" className="flex min-h-[80vh] flex-col items-start justify-center px-6 pt-32 sm:px-12 lg:px-20">
      <Seo notFound />
      <p className="font-mono text-xs tracking-[0.4em] text-[#C5A059]">404</p>
      <h1 className="mt-6 font-serif text-6xl font-light leading-[0.9] text-[#F9F8F6] sm:text-8xl">
        {de ? "Diese Seite" : "This page"}<br /><span className="text-outline">{de ? "gibt es nicht." : "does not exist."}</span>
      </h1>
      <p className="mt-8 max-w-md font-sans text-sm leading-relaxed text-[#A1A1AA]">
        {de ? "Der Link ist veraltet oder die Adresse wurde falsch eingegeben. Hier geht es weiter:" : "The link is outdated or the address was mistyped. Continue here:"}
      </p>
      <nav aria-label={de ? "Weiterführende Links" : "Helpful links"} className="mt-8 flex flex-wrap gap-4">
        {[["/", de ? "Startseite" : "Home"], ["/bands", "Bands"], ["/music", "Music"], ["/contact", de ? "Kontakt" : "Contact"]].map(([p, l]) => (
          <Link key={p} to={lp(p)} data-testid={`notfound-link-${p.replace("/", "") || "home"}`} className="border border-white/15 px-6 py-3 font-sans text-[10px] uppercase tracking-[0.25em] text-[#A1A1AA] transition-colors hover:border-[#C5A059] hover:text-[#C5A059]">
            {l}
          </Link>
        ))}
      </nav>
    </section>
  );
};

export default NotFoundPage;
